// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"376":"ceb0d8db","4297":"4839a770","8530":"9e962f7a"}[chunkId] + ".chunk.css";
};